<div class="flex flex-middle">
  <p class="h3 m-r-3">{{title}}</p>
  <!-- count of results -->
  <div class="p3 col-12 no-wrap m-r">
    {{ (client.isS ? '(%)' : (listing.getTotal() === 1 ? '(% Product)' : '(% Products)')) | translate :
    listing.getTotal() }}
  </div>

  <div class="flex-grow"></div>

  <!-- filter by -->
  <button class="button"
    style="height: 40px; border-radius: 40px;"
  (click)="showFiltersModal()">{{'Filter' | translate}}</button>
</div>



<!-- Selected filters -->
@if (getFiltersForChips().length) {
  <div class="flex flex-wrap m-t-2"
    >
    @for (filter of getFiltersForChips(); track $index) {
      @for (selection of filter.getSelectedOptions(); track $index; let isLast = $last) {
        <button class="no-wrap col-12 inline-flex flex-middle"
          [class.m-r]="!isLast">
          <i class="inline-flex p-a-1 icon-close"
            [style.font-size.px]="12"
          (click)="filter.unselect(selection)"></i>&nbsp;
          <span class="inline-block p-t-2 p-b-2 p-t-2 no-wrap capitalize">
            {{filter.attribute.data.label}}&nbsp;-&nbsp;{{selection.label}}
          </span>
        </button>
      }
    }
  </div>
}

@if (noResults) {
  <div class="p2 m-t">{{'No results'| translate}}</div>
}